import React from 'react'
import {
    Card, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Button, Table,
    InputGroup, InputGroupAddon, Input
} from 'reactstrap';
import watchImg from '../../assets/2106235_sw6_coverHover_2k.jpg'
export default function WatchInfo() {
    return (
        <div>
            <div className="d-flex justify-content-between">
                <Card className="col-md-5">
                    <CardImg top width="100%" src={watchImg} alt="Card image cap" />
                    <CardBody>
                        <CardTitle>Description</CardTitle>
                        {/* <CardSubtitle>Card subtitle</CardSubtitle> */}
                        <CardText>Original Rolex 18 ct gold bracelet. You can determine your wrist size by measuring the inner length of your watch strap with the buckle closed.</CardText>
                        {/* <Button className="btn-outline-dark salesDeskBtn" >Add Watch</Button> */}
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <Button className="btn-outline-dark salesDeskBtn py-2 px-2 remove">-</Button>
                            </InputGroupAddon>
                            <Input size="lg" />
                            <InputGroupAddon addonType="append">
                                <Button className="btn-outline-dark salesDeskBtn py-2 px-4">Add Watch</Button>
                            </InputGroupAddon>
                        </InputGroup>
                    </CardBody>
                </Card>
                <Table className="col-md-6">
                    <tbody>
                        <tr>
                            <td className="text-nowrap"><b>Brand</b></td>
                            <td className="text-right">Rolex</td>
                        </tr>
                        <tr>
                            <td className="text-nowrap"><b>Model</b></td>
                            <td className="text-right">Yacht-Master</td>
                        </tr>
                        <tr>
                            <td className="text-nowrap"><b>Refrence number</b></td>
                            <td className="text-right">16628</td>
                        </tr>
                        <tr>
                            <td className="text-nowrap"><b>Caliber</b></td>
                            <td className="text-right">fully operational / checked for performance, authenticity and functionality</td>
                        </tr>
                        <tr>
                            <td className="text-nowrap"><b>Case number</b></td>
                            <td className="text-right">S291xxx</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
    )
}
